<template>
  <div class="dialog-wap">
    <el-dialog
      :model-value="visible"
      align-center
      width="480"
      :before-close="handleClose"
      class="error-dialog"
    >
      <template #header>
        <div class="my-header">
          <h4 class="px-2 pb-3 text-lg text-[#262626] font-semibold">
            作废
          </h4>
        </div>
      </template>
      <p class="text-base mb-2 text-[#262626]">
        确认要作废 {{ row.contractSubject }} 合同吗？
      </p>
      <el-form
        ref="formRef"
        class="add-platform-users-form"
        require-asterisk-position="right"
        label-position="top"
        :model="form"
        :rules="formRules"
      >
        <el-form-item prop="reason" label="作废原因">
          <el-input
            v-model="form.reason"
            type="textarea"
            :rows="3"
            class="w-[432px]"
            placeholder="请输入"
            maxlength="200"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            :loading="saveBtnLoading" @click="handleClose"
          >
            取消
          </el-button>
          <el-button type="primary" :loading="saveBtnLoading" @click="handleSubmit">
            确定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">

import { PropType, ref } from 'vue';
import { ElMessage } from 'element-plus';
import { queryContractCreateOperate } from '../../../../..';
import { IContractCreatePage } from '../../../../../types/contracts/contracts';

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  row: {
    type: Object as PropType<IContractCreatePage>,
    default: () => {},
  },
});

const emit = defineEmits<{close: []}>();

const saveBtnLoading = ref(false);
const formRef = ref();

const form = ref({ reason: '' });

const formRules = ref({
  reason: [
    {
      validator: (rule: any, value: string, callback: any) => {
        if (form.value.reason.length > 200) {
          callback('字数小于等于200字');
        }
        callback();
      },
      required: true,
    },
  ],
});

function handleClose() {
  formRef.value.resetFields();
  emit('close');
}

function handleSubmit() {

  formRef.value.validate((valid) => {
    if (valid) doSubmit();
  });
}

async function doSubmit() {

  saveBtnLoading.value = true;

  try {
    await queryContractCreateOperate({
      contractId: String(props.row.id),
      type: 1,
      reason: form.value.reason,
    });
    handleClose();
  } catch (error) {
    if ((error as Error).message) ElMessage.error((error as Error).message);
  }
  saveBtnLoading.value = false;

}

</script>

<style lang="scss" scoped>
.dialog-wap {
  :deep(.el-dialog__body) {
    padding-bottom: 6px;
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>
